import React from 'react';
import { observer } from 'mobx-react';
import { OwnerAvatar } from 'libs/forms/styles';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { Wrapper, IconStyled } from 'apps/profile/views/item.styles';

export const SpaceItem = observer(({ deleteHandler, item, fieldStore }) => (
  <Wrapper>
    <OwnerAvatar
      size='22px'
      src={imageSrc(
        item.content.avatar,
        item.content.imageFallbackPath,
        mainConf.imgSizes.profile.small,
      )}
      noMarginTop
    />
    {item[fieldStore.conf.labelKey]}
    <IconStyled onClick={() => deleteHandler(item)} name='close' size='8px' />
  </Wrapper>
));
